export const AUTH_ACTIONS = {
  LOGIN: 'LOGIN',
  SET_USER: 'SET_USER',
  LOGOUT: 'LOGOUT',
};
